import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import './TS_CollapsableContainer.scss';
import { ComponentSync } from '../../core/ComponentSync.js';
import { _className } from '../../utils/tools.js';
import { LL_V_L } from '../Layouts/index.js';
export class TS_CollapsableContainer extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps) {
        const state = this.state ? { ...this.state } : {};
        state.collapsed = nextProps.collapsed ?? this.state?.collapsed ?? (nextProps.initialCollapsed ?? true);
        state.contentRef ??= React.createRef();
        state.containerRef ??= React.createRef();
        return state;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        this.setContainerHeight();
    }
    componentDidMount() {
        if (this.state.collapsed)
            this.setContainerHeight();
        else
            setTimeout(() => this.setContainerHeight(), 10);
    }
    //TODO: check if this is still supposed to be here
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        // let res = super.shouldComponentUpdate(nextProps, nextState, nextContext);
        // if (!res)
        // 	res = !compare(this.props.collapsed, nextProps.collapsed);
        // return res;
        return true;
    }
    //######################### Logic #########################
    setContainerHeight = () => {
        if (!this.state.containerRef.current)
            return;
        const currentContent = this.state.contentRef.current;
        const maxHeight = this.state.collapsed
            ? 0
            : this.props.maxHeight ? this.props.maxHeight : currentContent.getBoundingClientRect().height;
        this.state.containerRef.current.style.maxHeight = typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight;
    };
    toggleCollapse = (e) => {
        //If shared-components is controlled, return
        this.props.onCollapseToggle?.(this.isCollapsed(), e);
        if (this.props.collapsed !== undefined)
            return;
        this.setState({ collapsed: !this.state.collapsed });
    };
    isCollapsed() {
        //Return the collapse from props if controlled, otherwise state
        return this.props.collapsed !== undefined ? this.props.collapsed : this.state.collapsed;
    }
    refreshContainerHeight = () => {
        if (!this.state.collapsed)
            this.setContainerHeight();
    };
    //######################### Render #########################
    renderCaret() {
        if (this.props.showCaret === false)
            return '';
        const collapsed = this.isCollapsed();
        const className = _className('ts-collapsable-container__header__caret', collapsed ? 'collapsed' : undefined);
        if (this.props.customCaret)
            return _jsx("span", { className: className, children: typeof this.props.customCaret === 'function' ? this.props.customCaret() : this.props.customCaret });
        return _jsx("span", { className: className, children: this.isCollapsed() ? '+' : '-' });
    }
    renderHeader() {
        const className = _className('ts-collapsable-container__header', this.isCollapsed() ? 'collapsed' : undefined, this.props.flipHeaderOrder ? 'flip' : undefined);
        return _jsxs("div", { className: className, onClick: this.toggleCollapse, onContextMenu: this.props.onHeaderRightClick, children: [this.renderCaret(), typeof this.props.headerRenderer === 'function' ? this.props.headerRenderer() : this.props.headerRenderer] });
    }
    renderContainer() {
        const className = _className('ts-collapsable-container__container', this.isCollapsed() ? 'collapsed' : undefined);
        return _jsx("div", { className: className, ref: this.state.containerRef, children: _jsx("div", { ref: this.state.contentRef, className: 'ts-collapsable-container__container-wrapper', style: { width: '100%' }, children: (typeof this.props.containerRenderer === 'function' ? this.props.containerRenderer() : this.props.containerRenderer) }) });
    }
    render() {
        const className = _className('ts-collapsable-container', this.props.className);
        return _jsxs(LL_V_L, { className: className, style: this.props.style, id: this.props.id, onMouseOver: this.props.onMouseOver, onMouseEnter: this.props.onMouseEnter, onMouseLeave: this.props.onMouseLeave, innerRef: this.props.innerRef, children: [this.renderHeader(), this.renderContainer()] });
    }
}
//# sourceMappingURL=TS_CollapsableContainer.js.map